<template>
    <div class="Minister-top informationborder margin-top1">
        <div class="Minister-top-top informationbackground">
            <div class="Minister-top-left information-top-color">产品信息</div>
        </div>
        <div class="product_information_content">
            <div style=" overflow: hidden;">
                <div class="product_information">
                    <el-input placeholder="请输入内容" :value="productInfo.brand" @input="changeInfo($event, 'brand')">
                        <template slot="prepend">
                            品牌名称
                        </template>
                    </el-input>
                </div>
                <div class="product_information">
                    <el-input
                        placeholder="请输入内容"
                        :value="productInfo.manufacturer"
                        @input="changeInfo($event, 'manufacturer')"
                    >
                        <template slot="prepend">
                            厂商名称
                        </template>
                    </el-input>
                </div>
                <div class="product_information">
                    <el-input placeholder="请输入内容" :value="productInfo.stock" @input="changeInfo($event, 'stock')">
                        <template slot="prepend">
                            库存数量
                        </template>
                    </el-input>
                </div>
                <!-- <div class="product_information" v-show="substitutions">
                    <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">
                        <el-select v-model="select" slot="prepend" placeholder="请选择">
                            <el-option label="UPC" value="1"></el-option>
                            <el-option label="EAN" value="2"></el-option>
                        </el-select>
                        <template slot="append">置换</template>
                    </el-input>
                </div>-->
                <div class="product_information" v-show="noDisplay">
                    <el-input
                        placeholder="请输入内容"
                        :value="productInfo.sku"
                        @input="changeInfo($event, 'sku')"
                        :readonly="pageType !== 'wait'"
                    >
                        <template slot="prepend">
                            父SKU
                        </template>
                    </el-input>
                </div>
                <div class="product_information" v-show="noDisplay">
                    <el-input
                        placeholder="请输入内容"
                        :value="productInfo.manufacturerNumber"
                        @input="changeInfo($event, 'manufacturerNumber')"
                    >
                        <template slot="prepend">
                            厂商编号
                        </template>
                    </el-input>
                </div>
                <div class="product_information">
                    <el-input
                        placeholder="请输入内容"
                        :value="productInfo.preprocessingTime"
                        @input="changeInfo($event, 'preprocessingTime')"
                    >
                        <template slot="prepend">
                            预处理时间
                        </template>
                        <template slot="append">
                            天(现货填1)
                        </template>
                    </el-input>
                </div>
                <!-- <div class="product_information" v-if="productInfo.eanUpc">
                    <el-input placeholder="请输入内容" :value="productInfo.eanUpc" readonly>
                        <template slot="prepend">EAN/UPC</template>
                        <el-button
                            slot="append"
                            :loading="loading==='changeEANUPC'"
                            @click="changeEANUPC"
                        >置换</el-button>
                    </el-input>
                </div>-->
            </div>
            <div class="address">
                <template v-for="(item, index) in productInfo.sourceLink">
                    <div class="address-input-box" :key="index">
                        <el-input
                            class="address-input"
                            placeholder="请输入内容"
                            :value="productInfo.sourceLink[index]"
                            @input="changeSourceLink($event, 'sourceLink', index)"
                        >
                            <template slot="prepend">
                                来源地址
                            </template>
                        </el-input>
                        <el-button type="primary" @click="changeSourceLink('jump', productInfo.sourceLink[index])">
                            访问来源地址
                        </el-button>
                        <el-button type="primary" @click="changeSourceLink('add', 'sourceLink')" v-if="index === 0">
                            新增来源地址
                        </el-button>
                        <el-button
                            type="danger"
                            @click="changeSourceLink('del', 'sourceLink', index)"
                            v-if="index !== 0"
                        >
                            删除来源地址
                        </el-button>
                    </div>
                </template>
            </div>
            <div class="address_remarks">
                <el-input placeholder="请输入内容" :value="productInfo.remarks" @input="changeInfo($event, 'remarks')">
                    <template slot="prepend">
                        备注
                    </template>
                </el-input>
            </div>
            <div class="price">
                <el-row type="flex" align="middle">
                    <span style="padding: 0 10px 0 0">产品定价</span>
                    <el-col :span="3">
                        <template v-if="pageType === 'wait'">
                            <el-input
                                placeholder="请输入内容"
                                v-model="productInfo.productPrice"
                                @blur="priceChange(productInfo.productPrice)"
                            >
                                <template slot="append">
                                    {{ productInfo.priceCurrency }}
                                </template>
                            </el-input>
                        </template>
                        <template v-else>
                            <span v-show="productInfo.productPrice">
                                {{
                                    productInfo.productPrice +
                                        (productInfo.priceCurrency ? `(${productInfo.priceCurrency})` : "")
                                }}
                            </span>
                            <el-button type="primary" @click="oneClickPrice">一键定价</el-button>
                        </template>
                    </el-col>
                </el-row>
            </div>
            <div class="product_bottom">
                <div class="product_left">
                    <span>状态：</span>
                    <el-select
                        :value="productInfo.productStatus"
                        placeholder="请选择"
                        @change="changeInfo($event, 'productStatus')"
                    >
                        <el-option
                            v-for="item in productStatusList"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </div>
            </div>
            <div class="product_bottom">
                <div class="product_right">
                    <span>完成状态：</span>
                    <el-radio-group v-model="productInfo.statusAudit" size="small">
                        <el-radio label="2" border>完成</el-radio>
                        <el-radio label="1" border>未完成</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <one-click-price
            ref="OneClickPrice" 
            :productPriceObject="productInfo.productPriceObject" 
            :exchange-rate-list="exchangeRateList" 
            :product-price-pojo="productInfo.productPricePojo" 
            @confirm="getMsgFormSon" 
            @setMoneyInfo="setMoneyInfo" 
        />
    </div>
</template>
<script>
import OneClickPrice from "../elasticFrame/OneClickPrice";
import { ajaxPost, Baseurl } from "../../../../api/api/api";
export default {
    components: { OneClickPrice },
    props: {
        pageType: {
            type: String,
            default: "",
        },
        productInfo: {
            type: Object,
            default() {
                return {};
            },
        },
        exchangeRateList: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            productStatusList: [
                { value: "New" },
                { value: "UsedLikeNew" },
                { value: "UsedVeryGood" },
                { value: "UsedGood" },
                { value: "UsedAcceptable" },
                { value: "CollectibleLikeNew" },
                { value: "CollectibleVeryGood" },
                { value: "CollectibleGood" },
                { value: "CollectibleAcceptable" },
                { value: "Refurbished Club" },
            ],
            noDisplay: true,
            substitutions: false,
            loading: "",
        };
    },
    mounted() {
        this.substitutions = this.$route.query.substitutionTrue;
        if (this.substitutions === undefined) {
            this.substitutions = false;
        } else {
            this.substitutions = this.$route.query.substitutionTrue;
        }
    },
    methods: {
        changeInfo(value, key) {
            console.log(value, key);
            if (key !== "productPriceObject" && key !== "sourceLink") {
                value = String(value);
            }
            const obj = { key, value };
            this.$emit("changeInfo", obj);
        },
        // 只用来处理 来源地址
        changeSourceLink(value, key, index) {
            const arr = JSON.parse(JSON.stringify(this.productInfo.sourceLink));
            if (value === "add") {
                if (arr.length >= 5) return;
                arr.push("");
            } else if (value === "del") {
                arr.splice(index, 1);
            } else if (value === "jump") {
                if (!key) {
                    this.$message.error("请输入来源地址");
                    return;
                }
                window.open(key, "_blank");
                return;
            } else {
                value = String(value).replace(/\s/g, "");
                arr.splice(index, 1, value);
            }
            this.changeInfo(arr, key);
        },
        oneClickPrice() {
            if (this.exchangeRateList.length <= 0) return;
            this.$refs.OneClickPrice.dialogOpen();
        },

        getMsgFormSon(priceObj) {
            const { areaName } = this.productInfo
            let productPriceValue = "";
            let tempObj = {};
            // const countryAreaName = this.productInfo;
            if (areaName === "ZH") {
                productPriceValue = priceObj.ZH.value;
            } else {
                productPriceValue = priceObj[areaName].value;
                tempObj[areaName] = priceObj[areaName];
                priceObj = tempObj;
            }
            this.changeInfo(productPriceValue, "productPrice");
            this.changeInfo(priceObj, "productPriceObject");
        },
        // 点击孵化器页面不显示
        Incubator() {
            this.noDisplay = false;
        },
        // 置换EAN/UPC - 去掉的
        // changeEANUPC() {
        //     const Handlerequest = () => {
        //         const UserInfo = JSON.parse(localStorage.getItem("role"));
        //         const API = Baseurl + "productController/resetEanUpc";
        //         const paramsData = {
        //             companyId: UserInfo.company_id,
        //             number: 1
        //         };
        //         ajaxPost(API, paramsData).then(res => {
        //             const { code, data } = res.data;
        //             if (code === 200) {
        //                 const { eanUpc } = data[0];
        //                 this.changeInfo(eanUpc, "eanUpc");
        //             }
        //         });
        //     };
        //     this.$confirm(
        //         "点击确定之后将会置换EAN/UPC码，重新上传之后可能导致原有SKU无法识别！您确定要重置吗？",
        //         "提示",
        //         {
        //             confirmButtonText: "确定",
        //             cancelButtonText: "取消",
        //             type: "warning"
        //         }
        //     )
        //         .then(() => {
        //             Handlerequest();
        //         })
        //         .catch(() => {
        //             this.$message({
        //                 type: "info",
        //                 message: "已取消操作"
        //             });
        //         });
        // }
        priceChange(price) {
            const countryTag = this.productInfo.areaName;
            this.productInfo.productPriceObject[countryTag].value = price;
            this.$emit("priceChange", price);
        },
        setMoneyInfo(data) {
            this.$emit('setMoneyInfo', data)
        }
    },
};
</script>

<style lang="scss" scoped>
.product_information_content {
    width: 97%;
    margin: 1% auto;
    .product_information {
        overflow: hidden;
        float: left;
        width: 23%;
        margin-right: 2%;
        padding: 10px 0;
        .el-select {
            width: 96px;
        }
    }
    .product_information:nth-child(4) {
        margin-right: 0;
    }
    .address {
        width: 80%;
        padding: 10px 0;
        .address-input-box {
            display: flex;
            align-items: flex-start;
            .address-input {
                width: 80%;
                margin: 0 20px 20px 0;
            }
            &:last-child .address-input {
                margin: 0 20px 0 0;
            }
        }
    }
    .address_remarks {
        padding: 10px 0;
    }
    .price {
        padding: 15px 0;
    }
    .product_bottom {
        overflow: hidden;
        padding: 10px 0;
        .product_left {
            display: flex;
            align-items: center;
        }
        .product_right {
            display: flex;
            align-items: center;
        }
    }
}
</style>
